<script lang="ts">
  import RightAside from "$components/+layout/SidePanel/RightAside.svelte";
  import IconButton from "$components/+blocks/IconButton/IconButton.svelte";
  import SidePanelLayout from "$components/+layout/SidePanel/SidePanelLayout.svelte";
  import { SidePanelState, Theme } from "models/shared-types";
  import { isLeftPanelExpanded } from "$stores/userPreferences";
  import { LEFT_SIDEPANEL_WIDTH_PX } from "$utils/consts";
  import { LeftAsideFilled, Moon, Sun } from "$components/+blocks/OVIcon";
  import { getStores } from "app/stores";
  import { canEditCommunitySettings } from "app/stores/permissions";
  import { showAdminPanel } from "app/stores/adminPanel";
  import { MAIN_CONTENT_ID } from "$components/+blocks/SkipLink/skiplink";

  /** Should the user be able to see the sidePanel - based on privacy/permission? */
  export let showSidePanel: boolean;

  const { userPreferences } = getStores();
</script>

<div class="flex w-full grow overflow-hidden">
  <!-- Only show sidebar to allowed users + not on some pages -->
  {#if showSidePanel}
    <SidePanelLayout
      show={$isLeftPanelExpanded}
      slideTo="right"
      width={LEFT_SIDEPANEL_WIDTH_PX}
      withOverlay
      overlayClickOutsideAction={() =>
        userPreferences.setLeftPanelExpansion(SidePanelState.Collapsed, false)}
    >
      <div class="flex h-full flex-col rounded-xl pt-3.5 pl-3">
        <slot name="sidebar" />

        <div
          class="mt-auto -ml-3 flex items-center justify-between px-2.5 py-3"
          class:justify-between={!$showAdminPanel}
          class:justify-end={$showAdminPanel}
        >
          {#if !($canEditCommunitySettings || $showAdminPanel)}
            <IconButton
              variant="tertiary"
              icon={$userPreferences.theme === Theme.Dark ? Moon : Sun}
              a11yLabel="Switch theme"
              customIconSize="h-[18px]"
              on:click={() => userPreferences.toggleTheme()}
            />
          {/if}

          <IconButton
            variant="tertiary"
            icon={LeftAsideFilled}
            a11yLabel="Collapse sidebar [⇧S]"
            customIconSize="h-[18px]"
            on:click={() => userPreferences.setLeftPanelExpansion(SidePanelState.Collapsed)}
          />
        </div>
      </div>
    </SidePanelLayout>
  {/if}

  <!-- {#if $permissionsFetched} -->
  <div class="relative flex h-full w-full overflow-hidden">
    <!-- Community server pages -->
    <div id={MAIN_CONTENT_ID} class="z-0 flex w-full flex-1 flex-col">
      <slot />
    </div>
  </div>
  <RightAside />
  <!-- {/if} -->
</div>
